import * as React from 'react';

const ProductBlockFooter = ({ children  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-block-footer"
    }, children);
};

export { ProductBlockFooter };
//# sourceMappingURL=ProductBlockFooter.js.map
